module.exports = __webpack_public_path__ + "static/rank-bg.557abfe2.png";